<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <div class="min-h-screen pb-16 bg-gray-50/40">
        <!-- Page header -->
        <section class="pt-28">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="max-w-2xl mx-auto text-center">
              <span
                class="inline-flex items-center gap-2 px-3 py-1 mb-3 text-xs font-semibold tracking-wide uppercase rounded-full text-primary bg-primary/10"
              >
                <span
                  class="inline-block w-1.5 h-1.5 rounded-full bg-primary"
                ></span>
                Profil
              </span>
              <h1
                class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl font-roboto-slab"
              >
                Pimpinan Jurusan
              </h1>
              <p class="mt-4 text-base leading-relaxed text-gray-500">
                Susunan pimpinan dan struktur organisasi.
              </p>
            </div>
          </div>
        </section>

        <!-- Cards -->
        <section class="mt-12">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="flex flex-wrap justify-center gap-6">
              <button
                v-for="(author, index) in formasi.data"
                :key="author.id || index"
                type="button"
                @click="viewProfile(author.id)"
                class="flex flex-col items-center w-full max-w-[260px] p-6 text-center transition-all duration-300 bg-white border border-gray-100 shadow-sm group rounded-2xl hover:shadow-lg hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
              >
                <div
                  class="w-28 h-28 mb-4 overflow-hidden bg-gray-100 rounded-full ring-4 ring-primary/10"
                >
                  <img
                    :src="getFotoUrl(author.dosen.foto)"
                    :alt="author.dosen.nama"
                    class="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3
                  class="text-base font-semibold leading-snug text-gray-900 font-roboto-slab"
                >
                  {{ author.dosen.nama }}
                </h3>
                <p class="mt-1 text-sm font-medium text-primary">
                  {{ author.jabatan.namajabatan }}
                </p>
                <span
                  class="inline-flex items-center gap-1 mt-3 text-xs text-gray-400 transition-colors group-hover:text-primary"
                >
                  <i class="fa-solid fa-eye"></i>
                  Lihat profil
                </span>
              </button>
            </div>

            <!-- Modal -->
            <div v-if="isModalOpen">
              <Loading
                v-if="isLoading"
                :active="isLoading"
                :can-cancel="false"
                :is-full-page="false"
              />
              <ProfilDewas
                v-else
                v-model:isOpen="isModalOpen"
                :formasi="viewFormasi"
                :title="`${viewFormasi?.jabatan?.namajabatan}`"
              />
            </div>
          </div>
        </section>
      </div>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import { defineProps, ref } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import ProfilDewas from "@/Components/Web/ProfilDewas.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

defineProps({
  formasi: {
    type: Object,
    required: true,
  },
});

const isModalOpen = ref(false);
const viewFormasi = ref(null);
const isLoading = ref(false);

function getFotoUrl(foto) {
  if (!foto) return "./images/user/user-01.png";
  if (/^https?:\/\//.test(foto) || foto.startsWith("/storage")) {
    return foto;
  }
  return "/storage/" + foto;
}

const viewProfile = async (id) => {
  isLoading.value = true;
  isModalOpen.value = true;
  viewFormasi.value = null;
  try {
    const response = await fetch(`/pejabat/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Response is not JSON");
    }
    const data = await response.json();
    viewFormasi.value = data.formasidata;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  } finally {
    isLoading.value = false;
  }
};
</script>
